import Cookie from 'js-cookie';

export default class Utils {
  /**
   * 
   * @param {string} name 
   */
  static getCookie(name) {
    return Cookie.get(name);
  }

  /**
   * 
   * @param {*} name 
   * @param {*} value 
   * @param {*} options 
   */
  static setCookie(name, value = null, options = null) {
    if(value === null) {
      Cookie.remove(name);
    } else {
      Cookie.set(name, value, options);
    }
  }
}


// WEBPACK FOOTER //
// ./src/lib/Utils.js